import { render } from "./update.vue?vue&type=template&id=fae2aff6&scoped=true&ts=true"
import script from "./update.vue?vue&type=script&lang=ts"
export * from "./update.vue?vue&type=script&lang=ts"

import "./update.vue?vue&type=style&index=0&id=fae2aff6&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae2aff6"]])

export default __exports__